import { render, staticRenderFns } from "./MobileSupportMenu.vue?vue&type=template&id=f4bb0a8a&scoped=true"
import script from "./MobileSupportMenu.vue?vue&type=script&lang=js"
export * from "./MobileSupportMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bb0a8a",
  null
  
)

export default component.exports